// import logo from './logo.svg';
// import './App.css';
import NavBar1 from "./Components/NavBar1";
import Home1 from "./Components/Home1"
import Footer from "./Components/Footer";
import Accounting from "./Components/Accounting1";
import Tax from "./Components/Tax1";
import AboutUs from "./Components/AboutUs1";
import { BrowserRouter, Route ,Routes } from "react-router-dom";
import ContactUs from "./Components/ContactUs1";
import ScrollToTop from "./Components/ScrollToTop";
import ServicesForm1 from "./Components/ServicesForm1";
import Form2 from "./Components/Form2";


function App() {
  return (
    <div>
      {/* <Accounting></Accounting> */}
      {/* <Tax></Tax> */}

      <BrowserRouter>
      <ScrollToTop></ScrollToTop>
        <NavBar1></NavBar1>

        <Routes>
          <Route path="/" element={<Home1></Home1>}/>
          <Route path="/about-us" element={<AboutUs/>} />
          <Route path="/tax" element={<Tax/>} />
          <Route path="/accounting" element={<Accounting/>} />
          <Route path="/contact-us" element={<ContactUs/>} />
          <Route path="/qoute-form" element={<ServicesForm1 />} />
          <Route path="/client-form" element={<Form2 />} />



        </Routes>
        <Footer></Footer>
      </BrowserRouter>

    </div>
  );
}

export default App;

